import { createSlice } from "@reduxjs/toolkit"
import { subcontractorsActions } from "./subcontractors.actions"


//Initial State For Subcontractors
const initialState = {

    serviceRegions: [],
    serviceCategories: [],

    subcontractorsListData : [],
    subcontractorsFilterData : null,
    subcontractorsError : "",
    activePagination : {},
    error: "",
    accountsStats : null,

    subcontractorsDetailsData: null,
    subcontractorNotes: [],
} 

const subcontractorsSlice = createSlice({
    name: 'subcontractors',
    initialState,
    reducers : {},
    extraReducers: (builder) => {        

        builder
        // ---------------- cases of get service regions -----------------
        .addCase(subcontractorsActions.getServiceRegionsAction.pending, (state, action: any) =>{
            state.error = "";
            state.serviceRegions = [];
        })
        .addCase(subcontractorsActions.getServiceRegionsAction.fulfilled, (state, action) =>{
            if(action?.payload?.status){
                state.serviceRegions = action?.payload?.data?.data
            }
            else{
                state.error = "Unable to Fetch Service Regions"
            }
        })
        .addCase(subcontractorsActions.getServiceRegionsAction.rejected, (state, action : any) =>{
            state.serviceRegions = [];
            state.error = action?.payload?.message || ""
        })

        // ---------------- cases of get service categories -----------------
        .addCase(subcontractorsActions.getServicesAction.pending, (state, action: any) =>{
            state.error = "";
            state.serviceCategories = [];
        })
        .addCase(subcontractorsActions.getServicesAction.fulfilled, (state, action) =>{
            if(action?.payload?.status){
                state.serviceCategories = action?.payload?.data?.data.map((service: any) => ({
                    label: service.label || "Unnamed",
                    value: service.id ||  ""
                }));
             }
            else{
                state.error = "Unable to Fetch Account Stats"
            }
        })
        .addCase(subcontractorsActions.getServicesAction.rejected, (state, action : any) =>{
            state.serviceCategories = [];
            state.error = action?.payload?.message || ""
        })

        // ---------------- cases of get Accounts counts -----------------
        .addCase(subcontractorsActions.getAccountStatusCount.pending, (state, action: any) =>{
            state.error = "";
            state.accountsStats = null;
        })
        .addCase(subcontractorsActions.getAccountStatusCount.fulfilled, (state, action) =>{
            if(action?.payload?.status){
                state.accountsStats = action?.payload?.data
            }
            else{
                state.error = "Unable to Fetch Account Stats"
            }
        })
        .addCase(subcontractorsActions.getAccountStatusCount.rejected, (state, action : any) =>{
            state.accountsStats = null;
            state.error = action?.payload?.message || ""
        })
        
        // ---------------- cases of subcontractors list api data ----------------------
        .addCase(subcontractorsActions.getSubcontractorsListAction.pending, (state, action:any) => {
            state.subcontractorsError = "";
            state.subcontractorsListData = [];
            state.subcontractorsFilterData = action?.meta?.arg;
            state.activePagination = {};
        })
        .addCase(subcontractorsActions.getSubcontractorsListAction.fulfilled, (state, action) => {
            if(action.payload?.data?.data){
                state.subcontractorsListData = action?.payload?.data?.data;
                state.activePagination = action.payload?.data?.pagination
                state.error = "";
            }
            else {
                state.error = "Unable to fetch projects list";
                state.activePagination = {}
            }
        })
        .addCase(subcontractorsActions.getSubcontractorsListAction.rejected, (state, action) => {
            state.subcontractorsListData = [];
            state.error = action?.error?.message || "Unable to fetch Subcontractors Lits"
            state.activePagination = {}
        })

        // ---------------- cases of subcontractors details api data ----------------------
        .addCase(subcontractorsActions.getSubcontractorsDetailsAction.pending, (state, action:any) => {
            state.subcontractorsDetailsData = null;
            state.subcontractorsError = "";
        })
        .addCase(subcontractorsActions.getSubcontractorsDetailsAction.fulfilled, (state, action) => {
            if (action?.payload?.data?.status===200) {
                state.subcontractorsDetailsData = action?.payload?.data?.data;
                state.error = "";
            }
            else {
                state.error = "Unable to fetch projects list";
                state.activePagination = {}
            }
        })
        .addCase(subcontractorsActions.getSubcontractorsDetailsAction.rejected, (state, action) => {
            state.subcontractorsDetailsData = null;
            state.error = action?.error?.message || "Unable to fetch Subcontractors Details"
        })

        // ---------------- cases of get subcontractor notes categories -----------------
        .addCase(subcontractorsActions.getSubcontractorNotesAction.pending, (state, action: any) =>{
            state.error = "";
            state.subcontractorNotes = [];
        })
        .addCase(subcontractorsActions.getSubcontractorNotesAction.fulfilled, (state, action) =>{
            if(action?.payload?.status === 200){
                state.subcontractorNotes = action?.payload?.data?.data
            }
            else{
                state.error = "Unable to Fetch Internal Notes";
            }
        })
        .addCase(subcontractorsActions.getSubcontractorNotesAction.rejected, (state, action : any) =>{
            state.subcontractorNotes = [];
            state.error = "Unable to Fetch Internal Notes";
        })
    },
})

export default subcontractorsSlice.reducer;